/**
 * Global roles: security rows with no station, each granting an Okta group a
 * role across NewsDesk (admin or dashboard). Global admins only.
 */

import catchErrors from './catchErrors'

export default {
  getGlobalRoles() {
    return catchErrors.get(`/v2/newsdesk/global-roles`, {
      cache: { ignoreCache: true }
    })
  },

  createGlobalRole(data) {
    return catchErrors.post(`/v2/newsdesk/global-roles`, data)
  },

  deleteGlobalRole(role, oktaGroup) {
    return catchErrors.delete(`/v2/newsdesk/global-roles/${role}/${oktaGroup}`)
  },

  /** Queues a member sync for the named Okta groups, so a new global role takes effect before the nightly sync. */
  syncGroupMembers(groupNames) {
    return catchErrors.post(`/sudo/admin/sync-okta-group-members`, { groups: groupNames })
  }
}
